import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";

import AgGrid from "../../../UI/AgGrid";

import { useItemImporterColumnDefs } from "../../../../hooks/Importer/Inventory/use-importer-column-defs";

type Props = {
  data: any[];
  type?: string;
  itemType?: string;
};

const ItemImporterTable = ({ data, type, itemType }: Props) => {
  const gridRef = useRef<AgGridReact>(null);

  const columnDefs: ColDef[] = useItemImporterColumnDefs(type, itemType);

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={columnDefs}
      height={665}
      rowData={data}
      disabledSidebar
    />
  );
};

export default ItemImporterTable;
